import Constants from "../utils/constants";
import { API } from "../apis/APIsConfig";

export function getAfiliado() {
  return API.get(Constants.APIURLS.OBTENERAFILIADO);
}

export function saveAfiliado(data) {
  return API.put(Constants.APIURLS.ACTUALIZARAFILIADO, data);
}

export function getProvincias(){
  return API.get(Constants.APIURLS.PROVINCIAS);
}

export function getMunicipios(idProvincia){
  return API.get(Constants.APIURLS.MUNICIPIOS + idProvincia);
}

export function getSectores(idMunicipio){
  return API.get(Constants.APIURLS.SECTORES + idMunicipio);
}